import { useCallback } from 'react';
import useVideoContext from '../useVideoContext/useVideoContext';
import { Track } from "livekit-client";
import { useAppStateContext } from "hooks/useAppState/useAppState";
import { useSessionContext } from "hooks/useSession";
import { constants } from "utils";
export default function useLocalVideoToggle() {
    const { room: { localParticipant }, localTracks, isVideoMuted } = useVideoContext();
    const videoTrack = localTracks.find((track) => track?.source.includes(Track.Source.Camera));
    const { isLowBandwidth, session } = useSessionContext();
    const { isRecordSessions, setIsVideoManuallyMuted } = useAppStateContext();
    const toggleVideoEnabled = useCallback((isManual) => {
        if (videoTrack && !isRecordSessions) {
            // Video is not allowed in Multiple Choice activity, but only if session recording is off
            if (session?.sessionActivityType === constants.CONSENSUS_ENUM || !isVideoMuted) {
                videoTrack.mute();
                if (isManual) setIsVideoManuallyMuted(true);
            } else if (isVideoMuted && !isLowBandwidth && isManual) {
                videoTrack.unmute();
                setIsVideoManuallyMuted(false);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoTrack, localParticipant, isVideoMuted, session, isLowBandwidth, setIsVideoManuallyMuted]);
    return { toggleVideoEnabled };
}
